import { useEffect, useRef, useState } from 'react';

interface Options {
    rootMargin?: string;
    threshold?: number | number[];
}

export const useIsElementVisible = <T extends HTMLElement = HTMLDivElement>(options: Options = {}) => {
    const ref = useRef<T | null>(null);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const el = ref.current;
        if (!el || typeof IntersectionObserver === 'undefined') {
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            {
                rootMargin: options.rootMargin ?? '0px',
                threshold: options.threshold ?? 0
            }
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, [options.rootMargin, options.threshold]);

    return { ref, isVisible };
};
